import VerifyMePanel from './VerifyMePanel'

export default VerifyMePanel
